import * as React from 'react';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import {ReactState} from "./Forms";
import {useTranslate} from "@tolgee/react";

export function ConfirmationDialog(props: {
    dialogOpenState: ReactState<boolean>,
    titleKey: string,
    bodyKey: string,
    action: () => void
}) {

    const [dialogOpen, setDialogOpen] = props.dialogOpenState;
    const {t} = useTranslate();

    return (
        <Dialog
            open={dialogOpen}
            // TransitionComponent={Transition}
            keepMounted
            onClose={() => setDialogOpen(false)}
            aria-describedby="alert-dialog-slide-description"
            closeAfterTransition={false}
        >
            <DialogTitle>{t(props.titleKey)}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {t(props.bodyKey)}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setDialogOpen(false)}>{t("cancel")}</Button>
                <Button onClick={() => {
                    setDialogOpen(false);
                    props.action();
                }}>{t("ok")}</Button>
            </DialogActions>
        </Dialog>);
}

